import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { ClientType } from '../ClientSearch.meta';

export interface Client {
  FirstName: string;
  LastName: string;
  DisplayableConsumerId: string;
  OrganizationName: string;
  ConsumerId: number;
  Type: ClientType;
}

const searchClients = async (term: string): Promise<Client[]> => {
  return authFetch(urlWithParams('/Adviser/Search', { term }));
};

export const useSearchClientsQuery = (term: string) => {
  return useQuery(
    queryKeys.searchClients(term),

    () => searchClients(term),

    {
      enabled: !!term,
    },
  );
};
